<!--
 * @FileDescription: 优惠券
 * @Author: 陈文景
 * @Date: 2023-03-25 14:06:04
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <li :class="['coupon-preview', { pointer: coupon.status === 0 }, { selected: coupon.status === 0 && coupon.selected }]" @click="onClickCoupon">
    <div :class="['coupon-img', { 'coupon-img-url': coupon.logoUrl }, { grayscale: [1, 2, 3].includes(coupon.status) }]">
      <img v-if="coupon.logoUrl" :src="coupon.logoUrl" class="coupon-logo" alt="coupon.png" />
      <!--
        1.已用优惠券:UsedCoupon.png
        2.可用优惠券:AvailableCoupon.png
     -->
      <template v-else>
        <img v-if="coupon.status === 0 || isDetails" src="~@/assets/img/AvailableCoupon.png" class="default-img" alt="coupon.png" />
        <img v-if="[1, 2, 3].includes(coupon.status)" src="~@/assets/img/UsedCoupon.png" class="default-img" alt="coupon.png" />
      </template>
    </div>
    <div class="coupon-text">
      <div class="money">
        <p class="sum">
          <span class="amount">{{ fixedType === 1 ? `$${reduction}` : `${reduction}%` }}</span>
          <span v-if="fixedType === 2" class="off">OFF</span>
        </p>
        <p class="available">{{ conditionsOfUse(useType, threshold) }}</p>
      </div>
      <div class="specified">
        <p>{{ applicableType(applicableTypeValue) }}</p>
        <p>{{ receiveUsageRules(overlayUseTypes) }}</p>
        <p>{{ `${formatTimeStamp(coupon.usableStartTime)} ~ ${formatTimeStamp(coupon.usableEndTime)}` }}</p>
      </div>
    </div>

    <!-- 可使用的优惠券选中的图标 -->
    <img v-if="coupon.status === 0 && coupon.selected" src="~@/assets/img/CouponSelected.png" class="coupon-selected-img" alt="coupon.png" />

    <!--
      1.已使用:UsedCouponMark.png
      2.已过期:ExpiredCouponMark.png
      3.不可用:UnavailableCouponMark.png
     -->
    <img v-if="coupon.status === 1" src="~@/assets/img/UsedCouponMark.png" class="used-coupon-mark-img" alt="coupon.png" />
    <img v-if="coupon.status === 2" src="~@/assets/img/ExpiredCouponMark.png" class="expired-coupon-mark-img" alt="coupon.png" />
    <img v-if="coupon.status === 3" src="~@/assets/img/UnavailableCouponMark.png" class="unavailable-coupon-mark-img" alt="coupon.png" />
  </li>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    coupon: {
      type: Object,
      required: false,
      default: () => ({})
    },
    isDetails: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      moment
    }
  },
  computed: {
    /**
     * 以下代码均为容错处理（避免空指针异常、抽离并复用了重复代码）
     */
    baseOne() {
      return !!(this.coupon && this.coupon.receiveUsageRules)
    },
    baseTwo() {
      return !!(this.baseOne && this.coupon.receiveUsageRules.offerTypeInfo)
    },
    baseThree() {
      return this.coupon.receiveUsageRules.offerTypeInfo.fixedType
    },
    baseFour() {
      return this.coupon.receiveUsageRules.conditionsOfUse
    },
    baseFive() {
      return this.coupon.receiveUsageRules.conditionsOfUse.useType
    },
    baseSix() {
      return this.coupon.receiveUsageRules.conditionsOfUse.threshold
    },
    baseSeven() {
      return this.coupon.receiveUsageRules.applicableProducts.applicableType
    },
    baseNine() {
      return this.coupon.receiveUsageRules.offerTypeInfo.reduction
    },
    baseEight() {
      return this.coupon.receiveUsageRules.overlayUseTypes
    },

    fixedType() {
      return this.baseTwo && this.baseThree ? this.baseThree : undefined
    },
    useType() {
      return this.baseOne && this.baseFour && this.baseFive ? this.baseFive : undefined
    },
    threshold() {
      return this.baseOne && this.baseFour && this.baseSix ? this.baseSix : undefined
    },
    applicableTypeValue() {
      return this.baseOne && this.coupon.receiveUsageRules.applicableProducts && this.baseSeven ? this.baseSeven : undefined
    },
    overlayUseTypes() {
      return this.baseOne && this.baseEight ? this.baseEight : undefined
    },
    reduction() {
      return this.baseTwo && this.baseNine ? this.baseNine : '-'
    },
    conditionsOfUse() {
      return (value, number) => {
        // 使用类型：1.无使用门槛 2.订单满多少钱减 3.订单满多少件减
        switch (value) {
          case 1:
            return 'No Strings Attached'
          case 2:
            return `Available On Orders Of $${number}+`
          case 3:
            return `Buy ${number} pcs to use`
          default:
            return '-'
        }
      }
    },
    applicableType() {
      return (value) => {
        // 全部商品可用 2.非全部活动商品可用 3.指定商品
        switch (value) {
          case 1:
            return 'For all items'
          case 2:
            return 'Applies to non-promotional products'
          case 3:
            return 'Applies to specified products'
          default:
            return '-'
        }
      }
    },
    receiveUsageRules() {
      return (value) => {
        if (value && value instanceof Array) {
          return value.length ? 'Stack promotion code' : 'Cannot stack promotion code'
        } else {
          return '-'
        }
      }
    },
    formatTimeStamp() {
      return (value) => {
        return value ? moment(value).format('MM/DD/YYYY') : '-'
      }
    },
    defaultTips() {
      return (value) => value || '-'
    }
  },
  methods: {
    /**
     * 点击优惠券时触发的事件
     */
    onClickCoupon() {
      if (this.coupon.status === 0) {
        this.$emit('click', this.coupon.id)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.coupon-preview {
  position: relative;
  display: flex;
  width: 364px;
  height: 124px;
  align-items: center;
  border-radius: 6px;
  background-color: #fff;
  border: 1px solid #cdd4dd;
  &.pointer {
    cursor: pointer;
  }
  &.selected {
    border-color: #e3444e;
  }
  .coupon-img {
    position: relative;
    display: flex;
    width: 76px;
    height: 100%;
    align-items: center;
    justify-content: center;
    &.coupon-img-url {
      &::after {
        content: '';
        position: absolute;
        top: 50%;
        right: 0;
        height: 86%;
        transform: translateY(-50%);
        border-right: 1px dashed #cdd4dd;
      }
    }
    &.grayscale {
      filter: grayscale(100%);
    }
    .coupon-logo {
      width: 60px;
      height: 60px;
      object-fit: cover;
      border-radius: 4px;
    }
    .default-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .coupon-text {
    flex: 1;
    display: flex;
    height: 100%;
    padding: 10px 10px 10px 20px;
    flex-direction: column;
    justify-content: space-between;
    .money {
      .sum {
        color: #10141d;
        font-weight: 500;
        .amount {
          font-size: 22px;
          margin-right: 5px;
        }
        .off {
          font-size: 16px;
        }
      }
      .available {
        color: #10141d;
        font-size: 12px;
        font-weight: 500;
      }
    }
  }
  .specified {
    color: #8b93a3;
    font-size: 12px;
  }

  .coupon-selected-img {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 36px;
  }

  .used-coupon-mark-img,
  .expired-coupon-mark-img,
  .unavailable-coupon-mark-img {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 36px;
  }
}
</style>
